import { Route, Switch } from 'react-router'

import { CreateCategory } from './pages/CreateCategory'
import { CreateMessage } from './pages/CreateMessage'
import { ListCategories } from './pages/ListCategories'
import { ListMessages } from './pages/ListMessages'
import { ListSuggestions } from './pages/ListSuggestions'
import React from 'react'
import { UpdateCategory } from './pages/UpdateCategory'
import { UpdateMessage } from './pages/UpdateMessage'

export const MessageTemplatesRouter = () => (
  <Switch>
    <Route exact path={`/message-templates`} component={ListMessages} />
    <Route exact path={`/message-templates/message/create`} component={CreateMessage} />
    <Route exact path={`/message-templates/category/create`} component={CreateCategory} />
    <Route exact path={`/message-templates/category/:id`} component={UpdateCategory} />
    <Route exact path={`/message-templates/message/:id`} component={UpdateMessage} />
    <Route exact path={`/message-templates/categories`} component={ListCategories} />
    <Route exact path={`/message-templates/suggestions`} component={ListSuggestions} />
  </Switch>
)
